import { setLoginBonus, setLoginDayNumber, getLoginBonus } from '@/auth'
import request from '@/request'
import store from '@/store'
import CONSTANTS from '@/constants'
const state = {
    default_token: null,
    total_point: null,
    pointSetting: null,
    userDetail: null
        // deviceId: getDeviceId(),
}
const mutations = {
    SET_DEFAULT_TOKEN: (state, token) => {
        state.default_token = token
    },
    SET_POINT_SETTING: (state, point) => {
        state.pointSetting = point
    },
    SET_USER: (state, user) => {
        state.userDetail = user
    },
}
const actions = {
    userFind({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/find',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getDefaultToken({ commit }, params) {
        let len = params.len
        let str = "";
        for (var i = 0; i < len; i++) {
            var rand = Math.floor(Math.random() * 62);
            var charCode = rand += rand > 9 ? (rand < 36 ? 55 : 61) : 48;
            str += String.fromCharCode(charCode);
        }
        commit('SET_DEFAULT_TOKEN', str)
        return str
    },
    // refreshToken({ commit }) {
    //     console.log('sssasfgrtgtr45678');
    //     return new Promise((resolve, reject) => {
    //         request({
    //             url: '/login/access_token',
    //             method: 'get'
    //         }).then(response => {
    //             searchUser();
    //         }).catch(error => {
    //             reject(error)
    //         })
    //     })
    // },
    likeUser({ commit }, params) {
        let pointSetting = null
        store.dispatch('user/getPointFee', {
            token: store.getters.defaultToken
        }).then(data => {
            pointSetting = data
            let sub_point_like = pointSetting.result.filter(item => {
                // console.log(parseInt(item.type))
                return item.slug === 'send_like' && parseInt(item.type) === CONSTANTS.SUB_ACTION_POINT
            })
            if (sub_point_like[0] && parseInt(pointSetting.balance) >= parseInt(sub_point_like[0].point)) {
                return new Promise((resolve, reject) => {
                    request({
                        url: '/user/like',
                        method: 'post',
                        data: params
                    }).then(response => {
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
                })
            } else {
                window.location = "/profile/buy-point"
            }

        })
    },
    getPointFee({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/point/fee',
                method: 'get',
                params: params
            }).then(response => {
                commit('SET_POINT_SETTING', response.data)
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    userShow({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/show',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    userProfile({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user',
                method: 'get',
                params: params
            }).then(response => {
                // Fix #11253 avatar not change after approve
                const d = new Date();
                response.data.avatar_url = response.data.avatar_url + '?time=' + d.getTime();

                let pathName = window.location.pathname
                if (pathName.split('/').length == 2 && (
                        pathName.includes('home') ||
                        pathName.includes('timeline') ||
                        pathName.includes('like') ||
                        pathName.includes('message') ||
                        pathName.includes('profile')
                    )
                ) {
                    let userDetail = response.data

                    store.dispatch('user/getNewUpdate', {
                        token: store.getters.defaultToken
                    }).then(data => {
                        userDetail.is_new_footprint = data.is_new_footprint
                        commit('SET_USER', userDetail)
                    })

                } else {
                    commit('SET_USER', response.data)
                }

                if (parseInt(getLoginBonus()) !== CONSTANTS.IS_BONUS) {
                    setLoginBonus(response.data.is_bonus)
                    setLoginDayNumber(response.data.login_days_number)
                }
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getNewUpdate({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/get_new_update',
                method: 'get',
                params: params
            }).then(response => {
                if (response.data) {
                    resolve(response.data)
                }

            }).catch(error => {
                reject(error)
            })
        })
    },

    userReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/report',
                method: 'post',
                data
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    userIndex({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user',
                method: 'get',
                params
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getQuestionData({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/get_profile_question',
                method: 'get',
                params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    userUpdate({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/update',
                method: 'post',
                data: data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getMessageTemplate({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/get_message_template',
                method: 'get',
                params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    saveMessageTemplate({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/save_message_template',
                method: 'post',
                data: data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getLockList({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/lock/list',
                method: 'get',
                params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },


    loadPage({ commit }, url) {
        return new Promise((resolve, reject) => {
            request({
                url: url,
                method: 'get',
                params: null
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    sendFavorite({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/favorites/index',
                method: 'post',
                data
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    sendUnFavorite({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/favorites/unFavorites',
                method: 'post',
                data
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    lockUser({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/lock',
                method: 'post',
                data
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    logout({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/logout',
                method: 'post',
                params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    sendContact({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/contact',
                method: 'post',
                data
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}